import { createContext, useContext, useState } from "react";

// Cria o contexto
const LoggedUserContext = createContext();

// Provedor do contexto
export const LoggedUserProvider = ({ children }) => {

    const [loggedUser, setLoggedUser] = useState(null);
  
    return (
      <LoggedUserContext.Provider value={{ loggedUser, setLoggedUser }}>
        {children}
      </LoggedUserContext.Provider>
    );
  };
  
  // Hook para facilitar o acesso ao contexto
  export const useLoggedUser = () => useContext(LoggedUserContext);